import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

const ProgressSteps = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeStep, setActiveStep] = useState("start");
  const { t } = useTranslation();

  // Update active step based on URL param
  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/super-tool/start")) {
      setActiveStep("start");
    } else if (path.includes("/super-tool/build")) {
      setActiveStep("build");
    } else if (path.includes("/super-tool/connect")) {
      setActiveStep("connect");
    } else if (path.includes("/super-tool/assess")) {
      setActiveStep("assess");
    }
  }, [location]);

  const handleStepChange = (step: string) => {
    setActiveStep(step);
    navigate(`/super-tool/${step}`);
  };

  return (
    <div className="flex items-center justify-between mb-8 border-b border-gray-300 dark:border-gray-700 pb-4">
      <div className="flex space-x-2 w-full">
        <button
          className={`flex items-center px-4 py-2 rounded-full transition-colors ${
            activeStep === "start"
              ? "bg-blue-500 dark:bg-blue-600 text-white"
              : "bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300"
          }`}
          onClick={() => handleStepChange("start")}
        >
          <span className="w-6 h-6 rounded-full bg-white dark:bg-gray-200 text-blue-500 dark:text-blue-600 flex items-center justify-center mr-2">
            1
          </span>
          {t("superTool.steps.start")}
        </button>
        <div className="border-t border-gray-300 dark:border-gray-600 w-10 self-center"></div>
        <button
          className={`flex items-center px-4 py-2 rounded-full transition-colors ${
            activeStep === "build"
              ? "bg-blue-500 dark:bg-blue-600 text-white"
              : "bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300"
          }`}
          onClick={() => handleStepChange("build")}
        >
          <span className="w-6 h-6 rounded-full bg-white dark:bg-gray-200 text-blue-500 dark:text-blue-600 flex items-center justify-center mr-2">
            2
          </span>
          {t("superTool.steps.build")}
        </button>
        <div className="border-t border-gray-300 dark:border-gray-600 w-10 self-center"></div>
        <button
          className={`flex items-center px-4 py-2 rounded-full transition-colors ${
            activeStep === "connect"
              ? "bg-blue-500 dark:bg-blue-600 text-white"
              : "bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300"
          }`}
          onClick={() => handleStepChange("connect")}
        >
          <span className="w-6 h-6 rounded-full bg-white dark:bg-gray-200 text-blue-500 dark:text-blue-600 flex items-center justify-center mr-2">
            3
          </span>
          {t("superTool.steps.connect")}
        </button>
        <div className="border-t border-gray-300 dark:border-gray-600 w-10 self-center"></div>
        <button
          className={`flex items-center px-4 py-2 rounded-full transition-colors ${
            activeStep === "assess"
              ? "bg-blue-500 dark:bg-blue-600 text-white"
              : "bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300"
          }`}
          onClick={() => handleStepChange("assess")}
        >
          <span className="w-6 h-6 rounded-full bg-white dark:bg-gray-200 text-blue-500 dark:text-blue-600 flex items-center justify-center mr-2">
            4
          </span>
          {t("superTool.steps.assess")}
        </button>
      </div>
    </div>
  );
};

export default ProgressSteps;
